<template>

    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <el-col :md="4" :lg="8">
                    <el-button size="mini" type="primary" icon="plus" @click="addPresalePromotion">添加商品预售活动</el-button>
                </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="id" width="60" label="编号"></el-table-column>
                <el-table-column prop="item_id" label="商品ID"></el-table-column>
                <el-table-column prop="item_bn" label="商品货号"></el-table-column>
                <el-table-column prop="item_name" label="商品名称"></el-table-column>
                <el-table-column prop="sale_type" label="预售类型"></el-table-column>
                <el-table-column label="预计发货日期">
                    <template slot-scope="scope">
                        <span style="font-weight:600;">{{scope.row.shipdays}}</span>天后
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <div class="operating-icons">
                            <el-button @click="updatePresalePromotion(scope.row)" type="text">
                                编辑
                            </el-button>
                            <el-button @click="closePresalePromotion(scope.row)" type="text">
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total='total_count' :page-size="params.pageSize">
                </el-pagination>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import {getGoodsPresaleList, deleteGoodsPresale} from '../../../../api/promotions'
export default {
    data() {
      return {
        memberTagDialog: false,
        form: {
            item_bn: '',
            shipdays: 1,
        },
        loading: false,
        activeName: 'all',
        params: {
          page: 1,
          pageSize: 20,
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {
      addTemplate () { // 添加商品预售
        this.memberTagDialog = true
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      addPresalePromotion() {
        this.$router.push({path: this.matchHidePage('editor')})
      },
      updatePresalePromotion(row) {
        this.$router.push({path: this.matchHidePage('editor/') + row.id})
      },
      getPresalePromotionsLists() {
        this.loading = true
        getGoodsPresaleList(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      closePresalePromotion(row) {
        let that = this
        var msg = '预售取消前请检查商品库存查询方式'
        this.$confirm(msg, '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              deleteGoodsPresale(row.id).then(res => {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                  duration: 2 * 1000,
                  onClose() {
                    that.getPresalePromotionsLists()
                  }
                })
              })
            }
            done()
          }
        })
      },
    },
    mounted() {
      this.getPresalePromotionsLists()
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?61e7dfd2